import { render, staticRenderFns } from "./3-SubProducts.vue?vue&type=template&id=3e2dd9c5&scoped=true"
import script from "./3-SubProducts.vue?vue&type=script&lang=js"
export * from "./3-SubProducts.vue?vue&type=script&lang=js"
import style0 from "./3-SubProducts.vue?vue&type=style&index=0&id=3e2dd9c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2dd9c5",
  null
  
)

export default component.exports